export const ROUTES = {
  AUTH: {
    ERROR: '/auth-error',
    UNAUTHORIZED: '/unauthorized',
  },
  HOME: '/',
  DASHBOARD: '/dashboard',
} as const;

// Type for routes
export type AppRoutes = typeof ROUTES; 